import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { trackEvents } from "@/common/events/events";
import FleetHero from "./components/FleetHero/FleetHero";
import FleetWhyChoose from "./components/FleetWhyChoose/FleetWhyChoose";
import FleetSteps from "./components/FleetSteps/FleetSteps";
import FleetForm from "./components/FleetForm/FleetForm";
import FleetFAQ from "./components/FleetFAQ/FleetFAQ";
var ALLOWED_REFERRALS = ["sub_menu", "footer", "direct_link"];
var FleetPage = function FleetPage() {
  // Fire b2b_page_view once on mount. referral_location comes from the entry
  // point (?referral_location=sub_menu|footer); defaults to direct_link.
  useEffect(function () {
    if (!__IS_CSR__) return;
    var url = new URL(window.location.href);
    var param = url.searchParams.get("referral_location");
    var referral_location = ALLOWED_REFERRALS.includes(param !== null && param !== void 0 ? param : "") ? param : "direct_link";
    trackEvents("b2b_page_view", {
      referral_location: referral_location
    });
    if (param) {
      url.searchParams["delete"]("referral_location");
      window.history.replaceState(window.history.state, "", url.toString());
    }
  }, []);
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    hasMobFooter: true
  }, /*#__PURE__*/React.createElement(FleetHero, null), /*#__PURE__*/React.createElement(FleetWhyChoose, null), /*#__PURE__*/React.createElement(FleetSteps, null), /*#__PURE__*/React.createElement(FleetForm, null), /*#__PURE__*/React.createElement(FleetFAQ, null));
};
export default FleetPage;